const CryptoJS = require('crypto-js');
const keySize = 256;
const iterations = 100;

export const Encrypt = (msg, pass) => {
   var salt = CryptoJS.lib.WordArray.random(128 / 8);
   var key = CryptoJS.PBKDF2(pass, salt, {
      keySize: keySize / 32,
      iterations: iterations,
   });
   var iv = CryptoJS.lib.WordArray.random(128 / 8);
   var encrypted = CryptoJS.AES.encrypt(msg, key, {
      iv: iv,
      padding: CryptoJS.pad.Iso10126,
      mode: CryptoJS.mode.CBC,
   }); // salt, iv wi
   // ll be hex 32 in length
   // append them to the ciphertext for use  in decryption
   var transitmessage = salt.toString() + iv.toString() + encrypted.toString();
   return transitmessage;
};
